import { domel } from '@easydata/ui';
export function getViewportSize() {
    var width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    var height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    return {
        width: width,
        height: height
    };
}
export function findHighestZIndex(elem) {
    var highest = 0;
    while (elem !== null) {
        var zindex = document.defaultView.getComputedStyle(elem, null)
            .getPropertyValue("z-index");
        if (zindex != 'auto') {
            var numZIndex = parseInt(zindex);
            if (numZIndex > highest) {
                highest = numZIndex;
            }
        }
        elem = elem.parentElement;
    }
    return highest;
}
// simetimes setting focus in the main thread doesn't work correctly (in Firefox). So we need to 'hack' it.
export function safeFocus(element) {
    setTimeout(function (_) {
        if (element) {
            element.focus();
        }
    }, 100);
}
export var eqCssPrefix = 'eqjs';
export var eqCssMobile = 'eqjs-mobile';
export function makeElementMaximizable(element) {
    domel(element)
        .addClass(eqCssPrefix + "-maximizable")
        .addChild('div', function (b) {
        b.addClass(eqCssPrefix + "-max-button")
            .on('click', function (e) {
            e.preventDefault();
            domel(element)
                .toggleClass(eqCssPrefix + "-maximized");
        });
    });
}
//# sourceMappingURL=utils.js.map